const initialState = {
  contacts: [],
  page: 1,
  nextPage: 1,
  total: 0,
  fetching: false,
  orderBy: 'last_message_time',
  order: 'DESC',
  search: '',
};

const reductions = {
  CONTACTS_STARTED_FETCHING_CONTACTS: (state, { payload }) => {
    const { order, orderBy, search } = payload;
    return Object.assign({}, state, { order, orderBy, search, fetching: true });
  },
  CONTACTS_FETCHED_CONTACTS: (state, { payload }) => {
    const { page, nextPage, total, data } = payload;
    return Object.assign({}, state, {
      page,
      nextPage,
      total,
      contacts: data,
      fetching: false,
    });
  },
  CONTACTS_FAILED_FETCHING_CONTACTS: (state, { payload }) => {
    return Object.assign({}, state, { fetching: false });
  },
};

const contactsRouteReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default contactsRouteReducer;
